import Cards from './Cards'

export { default as Card } from "./CardSwitcher";

export default Cards
